import { FC } from 'react'
import {
  ArrayInput, BooleanInput, SelectInput, SimpleFormIterator,
  TextInput, required,
} from 'react-admin'

const HTTP_METHOD_CHOICES = [
  { id: 'GET', name: 'GET' },
  { id: 'POST', name: 'POST' },
  { id: 'PUT', name: 'PUT' },
  { id: 'DELETE', name: 'DELETE' },
]

const PARAM_TYPE_CHOICES = [
  { id: 'string', name: 'string' },
  { id: 'integer', name: 'integer' },
  { id: 'boolean', name: 'boolean' },
  { id: 'object', name: 'object' },
]

export const ToolFormFields: FC = () => (
  <>
    <TextInput source="name" label="data.name" fullWidth validate={required()} />
    <TextInput source="description" label="data.description" fullWidth validate={required()} multiline />
    <SelectInput
      source="http_method"
      label="data.httpMethod"
      fullWidth
      validate={required()}
      choices={HTTP_METHOD_CHOICES}
    />
    <TextInput source="path" label="data.path" fullWidth validate={required()} />
    <ArrayInput source="parameters" label="data.parameters">
      <SimpleFormIterator inline>
        <TextInput source="name" label="data.paramName" validate={required()} />
        <SelectInput
          source="type"
          label="data.paramType"
          validate={required()}
          choices={PARAM_TYPE_CHOICES}
        />
        <TextInput source="description" label="data.description" />
        <BooleanInput source="required" label="data.required" />
      </SimpleFormIterator>
    </ArrayInput>
  </>
)
